import { PUBLIC_SWS_ENV } from '@/constants/env';

export const getStripePricingTableConfig = () => {
  if (
    typeof PUBLIC_SWS_ENV === 'string' &&
    ['prod', 'staging'].includes(PUBLIC_SWS_ENV)
  ) {
    return {
      id: 'prctbl_1QUd1IF895euvD41twBUThWk',
      publishableKey: 'pk_live_yjPmww4IyP4GtDeZwc3UbfDX',
    };
  }
  return {
    id: 'prctbl_1QNmb5GApK8JiNJ5r2ZsDuiE',
    publishableKey: 'pk_test_QGnVFbcYrrVg01bZ9NvOWoG6007qcPJfeQ',
  };
};
